import { createSlice } from "@reduxjs/toolkit";
import { initialAsync, trialAsync } from "./operations";
import { TrialState } from "./state";

// 初期状態のステータス
const initialState: TrialState = {
  apps: {
    initialize: "Initializing",
  },
  domains: {
    Products: undefined,
  },
};

export const trialSlice = createSlice({
  name: "trial",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initialAsync.pending, (state) => {
      state.apps = initialState.apps;
      state.domains = initialState.domains;
    });
    builder.addCase(initialAsync.fulfilled, (state, action) => {
      const { payload } = action;
      state.apps = payload.apps;
      state.domains = payload.domains;
    });
    builder.addCase(initialAsync.rejected, (state, action) => {
      state.apps.initialize = "initializeError";
    });
    builder.addCase(trialAsync.pending, (state) => {
      /* Empty Function */
    });
    builder.addCase(trialAsync.fulfilled, (state, action) => {
      /* Empty Function */
    });
    builder.addCase(trialAsync.rejected, (state, action) => {
      // TODO：errorを更新する
    });
  },
});

export default trialSlice.reducer;
